<template>
    <p :class="['field', { invalid: isInvalid }]">
        <label v-if="!omitLabel && required" :for="id"><slot></slot> *</label>
        <label v-if="!omitLabel && !required" :for="id"><slot></slot></label>
        <select multiple
                :id="id"
                :name="id"
                :disabled="disabled"
                v-model="selected"
                @blur="setTouched(true)">
            <option v-if="undefinedText" :value="undefinedValue">{{ this.undefinedText }}</option>
            <option v-for="option in options" :value="option.value">
                {{ option.text }}
            </option>
        </select>
        <span class="invalid_help" v-if="isInvalid && invalidText">{{ invalidText }}</span>
    </p>
</template>

<script>
	export default {
		name: "SelectBoxMulti",
		data() {
			return {
				touched: false,
				forcedInvalid: false,
				invalidText: null,
			}
		},
		props: ['id', 'value', 'label', 'options', 'undefinedValue', 'undefinedText', 'required', 'disabled', 'omitLabel'],
		computed: {
			selected: {
				get() {
					return this.value
				},
				set(newValue) {
          this.onChange(newValue)
				}
			},
			isInvalid: function () {
				return (this.touched && this.required && this.valueIsEmpty) || this.isForcedInvalid
			},
			valueIsEmpty() {
				return this.value === null || this.value === undefined || this.value === 0 || this.value === '0'
			},
			isForcedInvalid() {
				return this.forcedInvalid
			}
		},
		methods: {
			onChange(value) {
				if (value === '') {
					value = null
				}
				this.$emit('input', value)
				this.setTouched(true)
			},
			setTouched(value) {
				this.touched = value
			},
			setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/SelectBoxMulti.vue